import React from 'react';
import { LockClosedIcon } from '@radix-ui/react-icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Switch } from '@producer/ui-kit';

import { DragIcon } from '../../../components/icons/DragIcon';
import { ChevronRight } from '../../../components/icons/ChevronRight';
import { Property } from '../../../app/entities/property';

import styles from './sortable-property-item.module.scss';

interface SortablePropertyItemProps {
  property: Property;
  isVisible: boolean;
  onClick: (property: Property) => void;
  onToggle: (propertyId: string, value: boolean) => void;
}

export const SortablePropertyItem: React.FC<SortablePropertyItemProps> = ({
  property,
  isVisible,
  onClick,
  onToggle,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: property._id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const handleEditClicked = () => {
    if (property.isLocked) {
      return; // Don't allow editing locked properties
    }
    onClick(property);
  };

  return (
    <div ref={setNodeRef} style={style} className={styles.item}>
      <div className={styles.drag} {...attributes} {...listeners}>
        <DragIcon />
      </div>

      <p onClick={handleEditClicked} className={styles.name} data-locked={!!property.isLocked}>
        {property.name}
      </p>

      <div className={styles.actions}>
        <div>
          <Switch
            size="medium"
            isToggled={isVisible}
            onToggle={(value) => onToggle(property._id, value)}
          />
        </div>

        <button onClick={handleEditClicked} disabled={!!property.isLocked}>
          {property.isLocked ? <LockClosedIcon /> : <ChevronRight size={16} />}
        </button>
      </div>
    </div>
  );
};
